import React from "react";
import { motion } from "framer-motion";
import { BottomSheet } from "@/components/ui/bottom-sheet";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

interface ShippingSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

const shippingSections = [
  {
    title: "Delivery Areas and Timeframes",
    items: [
      {
        question: "What are the delivery timeframes?",
        answer: "Cairo and Giza: Delivery within 2 business days. Other Governorates in Egypt: Delivery within 3-4 business days."
      }
    ]
  },
  {
    title: "Shipping Options",
    items: [
      {
        question: "What shipping methods are available?",
        answer: "Standard Shipping: Delivered within the timeframes mentioned above. Express Shipping: Available for select locations upon request."
      }
    ]
  },
  {
    title: "Order Processing",
    items: [
      {
        question: "How long does order processing take?",
        answer: "Orders are processed within 24 hours after confirmation. Orders placed after 5 PM will be processed the next business day."
      }
    ]
  },
  {
    title: "Shipping Fees",
    items: [
      {
        question: "How much does shipping cost?",
        answer: "Shipping costs vary based on the delivery location and will be calculated at checkout."
      }
    ]
  },
  {
    title: "Order Tracking",
    items: [
      {
        question: "How can I track my order?",
        answer: "Once shipped, you will receive a tracking number via email or SMS."
      }
    ]
  },
  {
    title: "Failed Delivery Attempts",
    items: [
      {
        question: "What happens if delivery fails?",
        answer: "If the courier is unable to deliver your order, a second attempt will be made. If the order is not received, it will be returned to us, and additional shipping fees may apply for re-delivery."
      }
    ]
  },
  {
    title: "Contact Information",
    items: [
      {
        question: "How can I contact you about shipping?",
        answer: "For any shipping inquiries, please contact us at: 📧 help@teluasegh.com or 📞 01044916655"
      }
    ]
  }
];

export function ShippingSheet({ isOpen, onClose }: ShippingSheetProps) {
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 20 }}
        className="p-6"
      >
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-semibold">Shipping Policy</h2>
        </div>
        <div className="space-y-6">
          <p className="text-muted-foreground">
            At TEL U ASEGH, we strive to ensure a smooth and timely delivery process. 
            Please review our shipping policy below.
          </p>
          <Accordion type="single" collapsible className="w-full">
            {shippingSections.map((section, index) => (
              <div key={section.title} className="mb-6">
                <h3 className="text-lg font-medium mb-4">{section.title}</h3>
                {section.items.map((item, itemIndex) => (
                  <AccordionItem key={itemIndex} value={`${index}-${itemIndex}`}>
                    <AccordionTrigger className="text-left">
                      {item.question}
                    </AccordionTrigger>
                    <AccordionContent>{item.answer}</AccordionContent>
                  </AccordionItem>
                ))}
              </div>
            ))}
          </Accordion>
        </div>
      </motion.div>
    </BottomSheet>
  );
} 